import { useLanguage } from "@/lib/LanguageContext";
import { Star, Quote } from "lucide-react";

export const Reviews = () => {
  const { t } = useLanguage();

  return (
    <section id="reviews" data-testid="reviews-section" className="py-20 md:py-32 relative" style={{ background: '#081f33' }}>
      <div className="absolute inset-0 noise-overlay" />
      <div className="relative z-10 container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Header */}
        <div className="mb-16 text-center">
          <span className="text-teal text-xs tracking-[0.4em] uppercase font-body font-semibold mb-4 block">
            {t.reviews.subtitle}
          </span>
          <h2 className="font-heading text-3xl md:text-5xl tracking-wide uppercase font-bold text-white">
            {t.reviews.title}
          </h2>
          <div className="w-20 h-[3px] bg-gold mt-6 mx-auto" />
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.reviews.items.map((review, i) => (
            <div
              key={i}
              data-testid={`review-card-${i}`}
              className="relative bg-navy-paper border-l-[3px] border-gold p-8 hover:border-teal transition-all duration-500 group"
            >
              <Quote className="w-8 h-8 text-gold/20 absolute top-4 right-4" strokeWidth={1} />

              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: review.rating }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 text-gold fill-gold" strokeWidth={0} />
                ))}
              </div>

              <p className="font-body text-sm text-slate-300 leading-relaxed mb-6 italic">
                "{review.text}"
              </p>

              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-navy-dark border border-white/10 flex items-center justify-center font-heading text-sm text-gold">
                  {review.name.charAt(0)}
                </div>
                <div>
                  <p className="font-heading text-sm tracking-wider text-white">{review.name}</p>
                  <p className="font-body text-xs text-slate-500">{review.city}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
